/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import BeneficiaryAccountDetailsPopup from "../../../../components/Accounts/BeneficiaryAccount/BeneficiaryAccountDetailsPopup/index.jsx";
import BeneficiaryAccountViewAllPopup from "../../../../components/Accounts/BeneficiaryAccount/BeneficiaryAccountViewAllPopup/index.jsx";
import Loader from "../../../../components/Loader/Index";
import CommonAccountApprovalCard from "../../../../components/_utils/CommonAccountApprovalCard/index.jsx";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup/index.jsx";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index.jsx";
import {
  addBeneficiaryAccountLabel,
  approveBeneficiaryAccount,
  beneficiaryAccountDetailsById,
  getAllBeneficiaryAccounts,
  rejectBeneficiaryAccount,
  removeBeneficiaryAccountLabel,
} from "../../../../redux/features/accounts/beneficiaryAccount/index.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import {
  bankLookUp,
  getAllCategories,
  panLookUp,
} from "../../../../redux/features/sharedResources/sharedResources.js";
import { beneficiaryTransactionsReject } from "../../../../redux/features/transactions/beneficiaryTransactions/index.js";
import { scheduledBeneficiaryReject } from "../../../../redux/features/transactions/scheduleBeneficiaryTransactions/index.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider.js";
import globalText from "../../../../utils/globalText.js";
import BeneficiaryTransactionViewall from "../../../Transactions/BeneficiaryTransactions/BeneficiaryTransactionViewall/index.jsx";
import ScheduleBeneficiaryTransactionViewSchedules from "../../../Transactions/ScheduleBeneficiaryTransactions/ScheduleBeneficiaryTransactionViewSchedules/index.jsx";
import "./index.css";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams.js";
import UseHandleScroll from "../../../../hooks/useHandleScroll";
import BeneAccountDeclinePopup from "../../../../components/Accounts/BeneficiaryAccount/BeneAccountDeclinePopup/index.js";

const BeneficiaryAcountApproval = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filterRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);

  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams, handleClearSearchParam } =
    useCustomSearchParams({
      pageno: GlobalConfiguration.lengthCheckOne,
      pagesize: dropdownOptions[0],
    });

  const convertDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );
    return timestamp;
  };

  const [labels, setLabels] = useState([]);
  const [labelId, setLabelId] = useState([]);
  const [loading, setLoading] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [ifscCode, setIfscCode] = useState(searchParam.get("ifsc") || "");
  const [removePan, setRemovePan] = useState("");
  const [panNumber, setPanNumber] = useState(searchParam.get("pan") || "");
  const [inputData, setInputData] = useState([]);
  const [removeIFSC, setRemoveIFSC] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );
  const [isFocused, setIsFocused] = useState(false);
  const [allAccounts, setAllAccounts] = useState([]);
  const [accountName, setAccountName] = useState("");
  const [activeType, setActiveType] = useState("pan");
  const [showLoader, setShowLoader] = useState(false);
  const [removeAccount, setRemoveAccount] = useState("");
  const [accountNumber, setAccountNumber] = useState(
    searchParam.get("accno") || "",
  );
  const [associateType, setAssociateType] = useState("");
  const [endDateFilter, setEndDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[1]) || "",
  );
  const [showCategory, setShowCategory] = useState(false);
  const [searchUserText, setSearchUserText] = useState(
    searchParam.get("search") || "",
  );
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [currentCategory, setCurrentCategory] = useState(
    searchParam.get("category") || "",
  );
  const [rejectionReason, setRejectionReason] = useState("");
  const [displayCategory, setDisplayCategory] = useState(
    searchParam.get("dispCategory") || "",
  );
  const [LabelSearchText, setLabelSearchText] = useState(
    searchParam.get("label")?.split(",") || [],
  );
  const [whichBtnClicked, setWhichBtnClicked] = useState({});
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [startDateFilter, setStartDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[0]) || "",
  );
  const [activeFilterType, setActiveFilterType] = useState("");
  const [beneTxnDetailsId, setBeneTxnDetailsId] = useState("");
  const [pendingNavTarget, setPendingNavTarget] = useState(null);
  const [isAccountsLoading, setAccountsLoading] = useState(false);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [isLeavePageAlert, setIsLeavePageAlert] = useState(false);
  const [accountSummaryData, setAccountSummaryData] = useState([]);
  const [labelPopupAccounts, setLabelPopupAccounts] = useState([]);
  const [rejectedAccountId, setRejectedAccountId] = useState(null);
  const [isRejectPopupOpen, setIsRejectPopupOpen] = useState(false);
  const [openBeneAssociate, setOpenBeneAssociate] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [showScheduleTxnPopup, setShowScheduleTxnPopup] = useState(false);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [isBeneAccountDetailsOpen, setIsBeneAccountDetailsOpen] =
    useState(false);
  const [associatedAccountData, setAssociatedAccountData] = useState({
    panNumber: "",
    ifscCode: "",
    accountNumber: "",
    accountId: "",
    accountName: "",
  });

  const [direction, setDirection] = useState("");
  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const { handleScroll } = UseHandleScroll(setDirection, lastScrollTop);

  const allCategories = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );
  const services = useSelector((state) => state.refreshToken.services);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const {
    getAllBeneficiaryAccountsData,
    approveBeneficiaryAccountData,
    rejectBeneficiaryAccountLoading,
  } = useSelector((state) => state.beneficiaryAccount);

  const { scheduledBeneficiaryViewLoading, scheduledBeneficiaryViewData } =
    useSelector((state) => state?.scheduleBeneficiaryTransactions);

  const {
    beneficiaryTransactionsViewAllData,
    beneficiaryTransactionsViewAllLoading,
  } = useSelector((state) => state.beneficiaryTransactions);

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handlePagination = (page) => {
    handleSubmit("pageno", page);
    setCurrentPage(page);
  };

  const updateAllAccounts = (updatedAccounts) => {
    setAllAccounts(updatedAccounts);
  };

  const hasAnyFilter =
    displayCategory !== "" ||
    Boolean(currentCategory?.length) ||
    Boolean(LabelSearchText?.length) ||
    Boolean(accountNumber?.length) ||
    Boolean(panNumber?.length) ||
    Boolean(searchUserText?.length) ||
    (startDateFilter !== "" &&
      endDateFilter !== "" &&
      startDateFilter !== GlobalConfiguration.lengthCheckZero &&
      endDateFilter !== GlobalConfiguration.lengthCheckZero &&
      !isNaN(Number(startDateFilter)) &&
      !isNaN(Number(endDateFilter))) ||
    Boolean(ifscCode) ||
    Boolean(searchUserTextDebounce?.length);

  const noTransactionsFromAPI =
    !isAccountsLoading &&
    accountSummaryData &&
    accountSummaryData.total_count === GlobalConfiguration.lengthCheckZero &&
    !hasAnyFilter;

  const noResultsAfterFilter =
    !isAccountsLoading &&
    accumulatedData?.length === GlobalConfiguration.lengthCheckZero &&
    hasAnyFilter;

  const handleInputChange = (event) => {
    let value = event?.target?.value;

    value = value.replace(/[^a-zA-Z0-9\s]/g, "");
    value = value.replace(/^\s+/, "");

    value = value.replace(/\s{2,}/g, " ");

    value = value.slice(0, 150);

    setRejectionReason(value);
  };

  const fetchDataBeneAccountApproval = async () => {
    let response;
    let data = [];

    switch (activeFilterType) {
      case "Categories":
        response = await dispatch(
          getAllCategories({ search_string: searchUserTextDebounce }),
        );
        data = response?.payload?.categories?.map((itm) => {
          return {
            id: itm.id,
            Category: itm.name,
            Description: itm?.description || "Not given",
          };
        });
        setInputData(data);
        break;
      case "Labels":
        data = labels
          ?.filter((itm) => {
            if (itm.includes(searchUserTextDebounce)) return true;
            else return false;
          })
          ?.map((val) => {
            return { id: val, Label: val };
          });
        setInputData(data);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (activeFilterType?.length) {
      fetchDataBeneAccountApproval();
    }
  }, [activeFilterType]);

  const fetchData = async (isSilent = false) => {
    try {
      if (!isSilent) {
        setAccountsLoading(true);
      }

      let queryParams = {
        page_no: currentPage,
        page_size: pageSize,
        approval_status: ["pending"],
        type_of_account: "beneficiary",
      };
      if (currentCategory !== "") {
        queryParams.category_ids = Array.isArray(currentCategory)
          ? currentCategory
          : [currentCategory];
      }
      if (
        startDateFilter !== "" &&
        endDateFilter !== "" &&
        startDateFilter !== 0 &&
        endDateFilter !== 0 &&
        !isNaN(Number(startDateFilter)) &&
        !isNaN(Number(endDateFilter))
      ) {
        queryParams.start_date =
          startDateFilter + GlobalConfiguration.day_in_seconds;
        queryParams.end_date =
          endDateFilter + GlobalConfiguration.day_in_seconds;
      }
      if (accountNumber !== "") {
        queryParams.bank_account_no = accountNumber;
      }
      // if (currentCategory !== "") {
      //   queryParams.categoryName = currentCategory;
      // }

      if (panNumber !== "") {
        queryParams.pan = panNumber;
      }
      if (searchUserText !== "") {
        queryParams.search_string = searchUserText;
      }
      if (LabelSearchText?.length !== GlobalConfiguration.lengthCheckZero) {
        queryParams.labels = LabelSearchText;
      }
      if (ifscCode !== "") {
        queryParams.ifsc = ifscCode;
      }

      const response = await dispatch(getAllBeneficiaryAccounts(queryParams));

      const newData = (response?.payload?.beneficiary_accounts || []).map(
        (account) => ({
          ...account,
          loading: false,
          error: "false",
          message: "",
        }),
      );

      setAllAccounts(() => [...newData]);
      setAccountSummaryData(response?.payload);
      setLabels(response?.payload?.summary?.available_labels);
      const rawData = response?.payload?.beneficiary_accounts || [];
      setAccumulatedData(rawData);
    } catch (error) {
      console.error("Error fetching beneficiary accounts:", error);
    } finally {
      setAccountsLoading(false);
    }
  };

  const handleDateChange = (date) => {
    if (date) {
      const [start, end] = date;
      setStartDateFilter(convertDate(start));
      setEndDateFilter(convertDate(end));
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
    }
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    fetchData();
  }, [
    dispatch,
    currentPage,
    pageSize,
    startDateFilter,
    endDateFilter,
    accountNumber,
    accountName,
    panNumber,
    searchUserText,
    ifscCode,
    currentCategory,
    LabelSearchText,
    markerData,
    displayCategory,
  ]);

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    setDirection("");
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(Number(currentPage));
    toggleDropdown();
  };

  const filteredData = accumulatedData;

  const handleOpenPopup = (id) => {
    setShowPopup(true);
    setRejectedAccountId(id);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setRejectionReason("");
    setWhichBtnClicked((p) => {
      return {
        ...p,
        [rejectedAccountId]: "none",
      };
    });
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);
    setLabelId([]);
    setLabelPopupAccounts([]);

    if (labelActionDispatchedRef.current) {
      labelActionDispatchedRef.current = false;
    }
  };

  const handleCloseModal = () => {
    if (isLeavePageAlert) return;
    setOpenBeneAssociate(false);
  };

  const onClose = () => {
    setIsRejectPopupOpen(false);
  };

  const handleApprovalToastSuccess = () => {
    CommonToast({
      text: "Account approved successfully.",
      icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
      variant: "var(--success)",
      buttonNeeded: false,
    });
  };

  const handleApproval = async (id) => {
    setLoading((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: true,
    }));
    UniversalRefreshToast("approvalaccountsRefresh");

    const data = await dispatch(approveBeneficiaryAccount({ id }));

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "BAAccount",
        },
      });
      return;
    }

    let errorMessage = "";
    if (data) {
      const errors = data?.payload?.errors;

      if (errors?.beneficiary_account?.[0]) {
        errorMessage = errors.beneficiary_account[0];
      } else if (errors?.bank_account_number?.[0]) {
        errorMessage = errors.bank_account_number[0];
      } else if (!data?.payload?.status) {
        errorMessage = errors?.category?.[0];
      } else {
        errorMessage = "An unknown error occurred.";
      }
    }

    if (data) {
      const updatedData = allAccounts.map((item) => {
        if (item.id === id) {
          let lifecycleStatus = "";

          if (data.payload.status === true) {
            lifecycleStatus = "Approved";
          }
          if (data.payload.status === false) {
            lifecycleStatus = "error";
          }

          let message = "";
          if (data.payload.status === false) {
            const errors = data?.payload?.errors;
            if (errors?.beneficiary_account?.[0]) {
              message = errors.beneficiary_account[0];
            } else if (data?.payload?.errors === "false") {
              message = errors?.category?.[0];
            } else if (errors?.bank_account_number?.[0]) {
              message = errors.bank_account_number[0];
            }
          }

          return {
            ...item,
            approval_status:
              item.approval_status === "pending" ? lifecycleStatus : "pending",
            error:
              item.error === "false" && data?.payload.status === false
                ? "true"
                : "false",
            message:
              item.message === "" && data.payload.status === false
                ? message
                : "",
          };
        }

        return item;
      });

      setAllAccounts(updatedData);

      if (data?.payload.status === false) {
        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    }

    setTimeout(() => {
      setLoading((prevLoadingStates) => ({
        ...prevLoadingStates,
        [id]: false,
      }));
    }, IntervalConfiguration.intervalExtraLarge);

    setTimeout(() => {
      if (data.payload.status === true) {
        handleApprovalToastSuccess();
      }
    }, IntervalConfiguration.intervalExtraLarge);
  };

  const handleBeneAccountMoreDetails = (id) => {
    setBeneTxnDetailsId(id);
    setIsBeneAccountDetailsOpen((prev) => !prev);
  };

  const handleCloseBeneAccountDetails = () => {
    setIsBeneAccountDetailsOpen(false);
  };

  const openAssociatedAccountsFound = (
    ifscCode,
    accountNumber,
    panNumber,
    accountId,
  ) => {
    dispatch(panLookUp({ pan_number: panNumber }));

    dispatch(
      bankLookUp({
        ifsc: ifscCode,
        bank_account_no: accountNumber,
      }),
    );

    setAssociatedAccountData((previousData) => ({
      ...previousData,
      ifscCode,
      accountNumber,
      accountId,
      panNumber,
    }));

    setRemovePan(panNumber);
    setOpenBeneAssociate(true);
  };

  const openTxnPopup = (accountId, accountName) => {
    setAssociatedAccountData((previousData) => ({
      ...previousData,
      accountId,
      accountName,
    }));
  };
  const handleCardClick = (targetPath) => {
    setPendingNavTarget(targetPath);
    setIsLeavePageAlert(true);
  };

  const handleLeaveConfirm = () => {
    setIsLeavePageAlert(false);
    setOpenBeneAssociate(false);
    if (pendingNavTarget) {
      navigate(pendingNavTarget);
    }
    setPendingNavTarget(null);
  };

  const handleAlertCancel = () => {
    setIsLeavePageAlert(false);
    setPendingNavTarget(null);
  };

  const handleClearFilters = () => {
    handleClearSearchParam();
    setAccountsLoading(true);
    setStartDateFilter("");
    setEndDateFilter("");
    setShowSearchBar(false);
    setCurrentCategory("");
    handleClearSearchParam();
    setPanNumber("");
    setAccountNumber("");
    setIfscCode("");
    setLabelSearchText([]);
    setSearchUserTextDebounce("");
    setSearchUserText("");
    handleClearSearchParam();
  };

  const emptyStateButtonProps = {
    btnText: noResultsAfterFilter
      ? "Clear parameters"
      : "Beneficiary account dashboard",

    handleFunction: noResultsAfterFilter
      ? handleClearFilters
      : () => navigate("/beneficiary_account_dashboard"),
  };

  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };

  // Beneficiary Txn & Schedule beneficiary txn check
  const handleRejectTransactionChecker = async (id, AccountIdData) => {
    setShowPopup(false);

    const accountInfo = await dispatch(
      beneficiaryAccountDetailsById({ id: rejectedAccountId }),
    );
    const acc = accountInfo?.payload?.beneficiary_accounts?.[0];

    if (acc?.pending_beneficiary_transactions === "Y") {
      setIsRejectPopupOpen(true);
    } else if (acc?.pending_scheduled_beneficiary_transactions === "Y") {
      setShowScheduleTxnPopup(true);
    } else {
      handleConfirm(id, AccountIdData);
    }
  };

  const handleConfirm = async (id, rejection_reason) => {
    setShowLoader(true);
    UniversalRefreshToast("accountsRefresh");

    if (
      !rejectBeneficiaryAccountLoading ||
      rejectBeneficiaryAccountLoading === null
    ) {
      const result = await dispatch(
        rejectBeneficiaryAccount({ id, rejection_reason }),
      );

      await new Promise((resolve) =>
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
      );

      if (result?.payload?.status === false) {
        let errorMsg = "";

        if (result?.payload?.errors?.beneficiary_account?.[0]) {
          errorMsg = result?.payload?.errors?.beneficiary_account[0];
        } else if (result?.payload?.errors?.bank_account_number?.[0]) {
          errorMsg = result?.payload?.errors?.bank_account_number[0];
        } else if (!result?.payload?.status) {
          errorMsg = result?.payload?.errors?.category?.[0];
        } else {
          errorMsg = "An unknown error occurred.";
        }

        const updatedData = allAccounts?.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "error" : "pending",
              rejected_on: "",
              rejected_by_name: "",
              rejection_reason: rejection_reason,
              error: "true",
              message: errorMsg,
              pending_beneficiary_transactions: "N",
              pending_scheduled_beneficiary_transactions: "N",
            };
          }
          return item;
        });

        updateAllAccounts(updatedData);

        setShowLoader(false);
        setShowPopup(false);
        setRejectionReason("");
        onClose();
        CommonToast({
          text: errorMsg,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else {
        const updatedData = allAccounts.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status: "rejected",
              rejected_on:
                result?.payload?.beneficiary_accounts?.[0]?.rejected_on ?? "",
              rejected_by_name:
                result?.payload?.beneficiary_accounts?.[0]?.rejected_by_name ??
                "",
              rejection_reason: rejection_reason,
              error: "false",
              message: "",
              pending_beneficiary_transactions: "N",
              pending_scheduled_beneficiary_transactions: "N",
            };
          }
          return item;
        });

        updateAllAccounts(updatedData);
        setShowLoader(false);
        setRejectionReason("");
        setAssociateType("");
        onClose();
        setShowPopup(false);
        CommonToast({
          text: "Account rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
      }
    }
  };

  // Reject benificiary transactions
  const handleRejectBeneTxn = async () => {
    setShowLoader(true);

    const id2 =
      !beneficiaryTransactionsViewAllLoading &&
      beneficiaryTransactionsViewAllData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? beneficiaryTransactionsViewAllData.transactions.map(
            (data) => data.txn_id,
          )
        : [];

    UniversalRefreshToast("Rejecting transaction");

    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      const data = await dispatch(
        beneficiaryTransactionsReject({ id: id2, reason: rejectionReason }),
      );

      if (
        data?.payload?.errors?.user_unauthorized?.length >
        GlobalConfiguration.lengthCheckZero
      ) {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "ABeneficiaryTxn" },
        });
        return;
      }

      await new Promise((resolve) =>
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
      );

      if (beneficiaryTransactionsReject.rejected.match(data)) {
        const errorMsg = data?.payload?.errors?.user_unauthorized
          ? data.payload.errors.user_unauthorized[0]
          : Array.isArray(data?.payload?.errors?.base) &&
              Array.isArray(data?.payload?.errors?.base[0]?.errors)
            ? data.payload.errors.base[0].errors[0]
            : data?.payload?.errors?.base?.[0];
        CommonToast({
          text: errorMsg,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setShowLoader(false);
        return;
      }

      if (beneficiaryTransactionsReject.fulfilled.match(data)) {
        setIsRejectPopupOpen(false);
        CommonToast({
          text: "Transaction rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });

        setAllAccounts((prevAccounts) =>
          prevAccounts.map((item) =>
            item.id === associatedAccountData?.accountId
              ? { ...item, pending_beneficiary_transactions: "N" }
              : item,
          ),
        );
      }
    }

    if (associateType === "rejectAccount") {
      const item = allAccounts?.find(
        (i) => i.id === associatedAccountData?.accountId,
      );
      if (item?.pending_scheduled_beneficiary_transactions === "Y") {

        setShowScheduleTxnPopup(true);
      } else {
        handleConfirm(rejectedAccountId, rejectionReason);
      }
    }

    setTimeout(() => {
      setIsRejectPopupOpen(false);
    }, IntervalConfiguration.intervalMedium);

    if (associateType !== "rejectAccount") {
      setRejectionReason("");
      setAssociateType("");
    }
    setShowLoader(false);
    setShowPopup(false);
  };

  const handleRejectScheduleTxn = async () => {
    const transactionIds =
      !scheduledBeneficiaryViewLoading &&
      scheduledBeneficiaryViewData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? scheduledBeneficiaryViewData?.transactions.map(
            (transaction) => transaction?.txn_id,
          )
        : [];
    UniversalRefreshToast("Rejecting transaction");
    if (transactionIds.length > GlobalConfiguration.lengthCheckZero) {
      const rejectResponse = await dispatch(
        scheduledBeneficiaryReject({
          id: transactionIds,
          reason: rejectionReason,
        }),
      );
      if (rejectResponse?.payload?.status === false) {
        const errorMessage = rejectResponse?.payload?.errors?.user_unauthorized
          ? rejectResponse.payload.errors.user_unauthorized[0]
          : Array.isArray(rejectResponse?.payload?.errors?.base) &&
              Array.isArray(rejectResponse.payload.errors.base[0]?.errors)
            ? rejectResponse.payload.errors.base[0].errors[0]
            : rejectResponse?.payload?.errors?.base?.[0];
        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });

        setTimeout(() => {
          setShowScheduleTxnPopup(false);
        }, IntervalConfiguration.intervalMedium);

        setShowLoader(false);
      } else if (rejectResponse?.payload?.status === true) {
        setShowScheduleTxnPopup(false);
        CommonToast({
          text: "Scheduled transactions rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });

        setTimeout(() => {
          setShowScheduleTxnPopup(false);
        }, IntervalConfiguration.intervalMedium);

        const updatedAccounts = allAccounts?.map((account) => {
          if (account.id === associatedAccountData?.accountId) {
            return {
              ...account,
              pending_scheduled_beneficiary_transactions: "N",
            };
          }
          return account;
        });

        updateAllAccounts(updatedAccounts);
        if (associateType === "rejectAccount") {
          handleConfirm(rejectedAccountId, rejectionReason);
        }
      }
      setRejectionReason("");
      setAssociateType("");
      setShowPopup(false);
    }
  };

  const getErrorMessage = (response) => {
    const payload =
      response?.payload?.response?.data?.ids?.unsuccessful_ids?.[0]?.errors ||
      response?.payload;
    const error = response?.error;
    if (typeof payload === "string") {
      return payload;
    }
    if (payload?.message) {
      return payload.message;
    }
    if (payload?.errors?.base?.[0]) {
      const baseError = payload.errors.base[0];

      return typeof baseError === "string"
        ? baseError
        : baseError?.errors?.[0] || baseError?.message;
    }
    if (error?.message) {
      return error.message;
    }
    return "Something went wrong";
  };

  const handleAssignLabels = async (labelsToAssign) => {
    const normalizeToArray = (value) =>
      Array.isArray(value) ? value : [value];
    const accountIds = normalizeToArray(labelId);
    const response = await dispatch(
      addBeneficiaryAccountLabel({
        record_ids: accountIds,
        labels: labelsToAssign,
      }),
    );
    if (addBeneficiaryAccountLabel?.fulfilled?.match(response)) {
      setLabelPopupAccounts((previousAccounts) =>
        previousAccounts.map((account) => ({
          ...account,
          labels: [...new Set([...(account.labels || []), ...labelsToAssign])],
        })),
      );

      setAllAccounts((previousAccounts) =>
        previousAccounts.map((account) => {
          if (accountIds.includes(account.id)) {
            return {
              ...account,
              labels: [
                ...new Set([...(account.labels || []), ...labelsToAssign]),
              ],
            };
          }
          return account;
        }),
      );

      fetchData(true);
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        buttonNeeded: false,
      });
      if (labelActionDispatchedRef) {
        labelActionDispatchedRef.current = true;
      }
      return true;
    }
    if (addBeneficiaryAccountLabel?.rejected?.match(response)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(response),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      fetchData(true);
    }

    return false;
  };

  const handleFunction = () => {
    if (associateType === "scheduleBeneTxn") {
      handleRejectScheduleTxn();
    } else if (associateType === "BeneTxn") {
      handleRejectBeneTxn();
    } else {
      handleRejectTransactionChecker(rejectedAccountId, rejectionReason);
    }
  };

  const handleUnassignLabels = async (labelsToUnassign) => {
    const normalizeToArray = (value) =>
      Array.isArray(value) ? value : [value];
    const accountIds = normalizeToArray(labelId);
    const response = await dispatch(
      removeBeneficiaryAccountLabel({
        record_ids: accountIds,
        labels: labelsToUnassign,
      }),
    );
    if (removeBeneficiaryAccountLabel?.fulfilled?.match(response)) {
      setLabelPopupAccounts((previousAccounts) =>
        previousAccounts.map((account) => ({
          ...account,
          labels: (account.labels || []).filter(
            (label) => !labelsToUnassign.includes(label),
          ),
        })),
      );

      setAllAccounts((previousAccounts) =>
        previousAccounts.map((account) => {
          if (accountIds.includes(account.id)) {
            return {
              ...account,
              labels: [
                ...new Set([...(account.labels || []), ...labelsToUnassign]),
              ],
            };
          }
          return account;
        }),
      );

      fetchData(true);
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        buttonNeeded: false,
      });
      if (labelActionDispatchedRef) {
        labelActionDispatchedRef.current = true;
      }
      return true;
    }
    if (removeBeneficiaryAccountLabel?.rejected?.match(response)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(response),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      fetchData(true);
    }

    return false;
  };

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  const REJECT_POPUP_CONTENT = {
    account: {
      headerTitle: globalText.REJECT_ACCOUNT,
      bulletPoints: [
        "New transactions cannot be created for this account.",
        "Before rejecting this account, reject all associated transactions and schedules.",
        "Users can edit the rejected account to update details.",
      ],
    },
    transactions: {
      headerTitle: "Rejecting Transactions",
      bulletPoints: [
        "Transaction will be rejected, and distribution will not be initiated.",
        "Transaction cannot be edited but can be recreated.",
      ],
    },
    schedules: {
      headerTitle: "Rejecting Schedules",
      bulletPoints: [
        "Once rejected, no transaction will be created.",
        "Rejected schedules cannot be edited. Create a new schedule instead.",
      ],
    },
  };

  const rejectPopupContent =
    associateType === "BeneTxn"
      ? REJECT_POPUP_CONTENT.transactions
      : associateType === "scheduleBeneTxn"
        ? REJECT_POPUP_CONTENT.schedules
        : REJECT_POPUP_CONTENT.account;

  return (
    <>
      {openBeneAssociate && (
        <div onClick={(e) => e.stopPropagation()}>
          <BeneficiaryAccountViewAllPopup
            onClose={handleCloseModal}
            onAccountSelect={(name, bankAccNo, ifscCode) => {
              handleCloseModal();
            }}
            associateAccount={true}
            associatepanNumber={associatedAccountData?.panNumber}
            associateIFSC={associatedAccountData?.ifscCode}
            associateaccountNumber={associatedAccountData?.accountNumber}
            beneAccountId={associatedAccountData?.accountId}
            accountType={"beneficiary"}
            flow={"beneTxn"}
            ispanbankRequired={true}
            setOpenBeneAssociate={setOpenBeneAssociate}
            activeType={activeType}
            setActiveType={setActiveType}
            remPan={removePan}
            setRemPan={setRemovePan}
            remAccount={removeAccount}
            setRemAccount={setRemoveAccount}
            remIFSC={removeIFSC}
            setRemIFSC={setRemoveIFSC}
            typePanBank={"BeneAccPanBankSwitch"}
            onCardNavigate={handleCardClick}
          />
        </div>
      )}

      {isLeavePageAlert && (
        <div
          className="fixed z-z-index-max flex items-center justify-center top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={(e) => e.stopPropagation()}
        >
          <SmallPopup
            headerTitle={globalText?.LEAVE_PAGE_WARNING_HEADER}
            headerFontWeight="semibold"
            headerFontColor="emphasis"
            textSize="font-lg"
            subtext={globalText?.LEAVING_PAGE_WILL_EXIT_FROM_CURRENT_FLOW}
            btnOneText={globalText?.STAY}
            btnOneHandleFunction={handleAlertCancel}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText={globalText?.LEAVE}
            btnTwoHandleFunction={handleLeaveConfirm}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
          />
        </div>
      )}

      {isLabelPopupOpen && (
        <div
          onClick={() => {
            setIsLabelPopupOpen(false);
          }}
          className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex"
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated accounts."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={labelId}
            isLabelPopupOpen={isLabelPopupOpen}
            filteredData={labelPopupAccounts}
            loading={isAccountsLoading}
            setLoading={setAccountsLoading}
            handleAssignLabels={handleAssignLabels}
            handleUnassignLabels={handleUnassignLabels}
          />
        </div>
      )}

      {isRejectPopupOpen && (
        <LargePopupRedirect
          headerTitle="Associated transactions found"
          headersubtext="The following transactions are linked and need to be rejected before rejecting this account."
          closeiconenabledBgColor="var(--primary-nav)"
          closeiconisLoading={false}
          closeiconhandleFunction={() => {
            setIsRejectPopupOpen(false);
            setWhichBtnClicked((p) => {
              return {
                ...p,
                [rejectedAccountId]: "none",
              };
            });
            setRejectionReason("");
          }}
          closeicon={ICONS?.CLOSE}
          closeiconhoverOption="white"
          closeiconbtnType={"button"}
          closeiconisDisabled={false}
          closeicondisabledBgColor={""}
          closeiconbuttonRef={null}
          closeicontitle={"Close"}
          btnType={"button"}
          bottomHeaderTextNeed={true}
          bottomHeaderText={
            "To reject the account, please reject the transactions listed above by clicking the “Reject all” button. The transactions will get rejected with the provided rejected reason."
          }
          isbottomSectionneed={true}
          btnText={"Reject all"}
          confirmbtnrequired={true}
          handleFunction={() => {
            if (associateType === "BeneTxn") {
              setShowPopup(true);
            } else {
              handleRejectBeneTxn();
            }
          }}
          enabledBgColor={"var(--negative-act)"}
          hoverOption={"dark"}
          outLineColor={""}
          enabledTextColor={"var(--text-primary)"}
          fullWidthRequired={false}
          isDisabled={false}
          disabledTextColor={""}
          disabledBgColor={""}
        >
          <BeneficiaryTransactionViewall
            bene_account_id={associatedAccountData?.accountId}
            typepop="BeneAccRejectTxn"
            closeRejectAllTxn={handleClosePopup}
            bene_account_name={associatedAccountData?.accountName}
          />
        </LargePopupRedirect>
      )}

      {showScheduleTxnPopup && (
        <LargePopupRedirect
          headerTitle="Associated schedules found"
          headersubtext="The following schedules are linked and need to be rejected before rejecting this account."
          closeiconenabledBgColor="var(--primary-nav)"
          closeiconisLoading={false}
          closeiconhandleFunction={() => {
            setShowScheduleTxnPopup(false);
            setWhichBtnClicked((p) => {
              return {
                ...p,
                [rejectedAccountId]: "none",
              };
            });
            setRejectionReason("");
          }}
          closeicon={ICONS?.CLOSE}
          closeiconhoverOption="white"
          closeiconbtnType={"button"}
          closeiconisDisabled={false}
          closeicondisabledBgColor={""}
          closeiconbuttonRef={null}
          closeicontitle={"Close"}
          btnType={"button"}
          bottomHeaderTextNeed={true}
          bottomHeaderText={
            "To reject the account, please reject the schedules listed above by clicking the “Reject all” button. The schedules will get rejected with the provided rejected reason."
          }
          isbottomSectionneed={true}
          btnText={"Reject all"}
          confirmbtnrequired={true}
          handleFunction={() => {
            if (associateType === "scheduleBeneTxn") {
              setShowPopup(true);
            } else {
              handleRejectScheduleTxn();
            }
          }}
          enabledBgColor={"var(--negative-act)"}
          hoverOption={"dark"}
          outLineColor={""}
          enabledTextColor={"var(--text-primary)"}
          fullWidthRequired={false}
          isDisabled={false}
          disabledTextColor={""}
          disabledBgColor={""}
        >
          <ScheduleBeneficiaryTransactionViewSchedules
            type="ScheduleAccBeneAcc"
            payload={{
              schedule_acc_id: associatedAccountData?.accountId,
              schedule_acc_name: associatedAccountData?.accountName,
            }}
            closeCallback={handleClosePopup}
          />
        </LargePopupRedirect>
      )}

      {showPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <BeneAccountDeclinePopup
            headerTitle={rejectPopupContent.headerTitle}
            bulletPoints={rejectPopupContent.bulletPoints}
            declineReason={rejectionReason}
            setDeclineReason={setRejectionReason}
            showLoader={showLoader}
            setShowLoader={setShowLoader}
            handleClosePopup={handleClosePopup}
            handleFunctionClick={handleFunction}
          />
        </div>
      )}

      {/* Account details in a modal */}
      {isBeneAccountDetailsOpen && (
        <BeneficiaryAccountDetailsPopup
          closeBeneAccountDetailModal={handleCloseBeneAccountDetails}
          bene_account_id={beneTxnDetailsId}
          type={"bene_account_detail_modal"}
          showCategory={showCategory}
        />
      )}

      {/* Entire page */}
      <div className="h-screen overflow-hidden flex flex-col">
        <div className="relative z-z-index-overlay bg-primary-nav min-h-height-base Qmd:min-h-navbar-breadcrumb-height"></div>

        <div className=" w-full relative z-z-index-header lg:px-padding-base flex items-center justify-end m-auto">
          <TopNavComponent
            direction={direction}
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: isAccountsLoading,
              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search beneficiary account",
              filterPlaceholder:
                "name / contact number / email ID / account ID",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchUserText,
                  setValue: (val) => {
                    handleSubmit("search", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setSearchUserText(val);
                  },
                  isDropdown: false,
                  isDisabled: false,
                },
                {
                  name: "Account number",
                  short_name: "Bene. Acc",
                  isMulti: false,
                  value: accountNumber,
                  setValue: (val) => {
                    handleSubmit("accno", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setAccountNumber(val);
                  },
                  isDropdown: false,
                  valueType: "string",
                  isDisabled: false,
                },
                {
                  name: "IFSC",
                  short_name: "IFSC",
                  isMulti: false,
                  value: ifscCode.toUpperCase(),
                  setValue: (val) => {
                    handleSubmit("ifsc", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setIfscCode(val);
                  },
                  valueType: "string",
                  isDropdown: false,
                  isDisabled: false,
                },
                {
                  name: "PAN",
                  short_name: "PAN",
                  isMulti: false,
                  value: panNumber.toUpperCase(),
                  setValue: (val) => {
                    handleSubmit("pan", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setPanNumber(val);
                  },
                  valueType: "string",
                  isDropdown: false,
                  isDisabled: false,
                },
                {
                  name: "Categories",
                  valueType: "string",
                  short_name: "Cat",
                  isMulti: false,
                  value: currentCategory,
                  displayValue: displayCategory,
                  setValue: (val) => {
                    const c =
                      allCategories.filter((x) => x.id === val)[0]?.name ?? "";
                    setDisplayCategory(c);
                    handleSubmit("category", val);
                    handleSubmit("dispCategory", c);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setCurrentCategory(val);
                  },
                  isDropdown: true,
                  isDisabled: false,
                },
                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: (val) => {
                    handleSubmit("label", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setLabelSearchText(val);
                  },
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: false,
                },
              ],
              filters: [
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateFilter && endDateFilter,
                  isDisable: false,
                  startDate: startDateFilter
                    ? new Date(
                        startDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : startDateFilter,
                  endDate: endDateFilter
                    ? new Date(
                        endDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : endDateFilter,
                  handleChange: (date) => {
                    handleSubmit("date", date);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleDateChange(date);
                  },
                },
              ],
              isFilterClearAllDisabled: !(startDateFilter && endDateFilter),
              isSearchClearAllDisabled: !(
                currentCategory !== "" ||
                displayCategory !== "" ||
                panNumber !== "" ||
                LabelSearchText?.length !==
                  GlobalConfiguration.lengthCheckZero ||
                ifscCode !== "" ||
                searchUserText !== "" ||
                accountNumber !== ""
              ),

              inputData: inputData,
              active: activeFilterType,
              setActive: setActiveFilterType,
              loading: isAccountsLoading,
              setLoading: (e) => {},
              isSortDisabled: isAccountsLoading,
              isFilterDisabled: isAccountsLoading,
              isShowFilter: true,
            }}
          />
        </div>
        <div
          style={{
            marginBottom: showInnerSearchBar ? "" : "var(--pagination-height)",
          }}
          className={`flex-1 flex flex-col overflow-hidden relative ${showInnerSearchBar ? "pointer-events-none" : ""}`}
        >
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop bg-opacity-dark-opacity pointer-events-none w-full h-full z-z-index-content"></div>
          )}
          <div
            style={{
              paddingBottom:
                getAllBeneficiaryAccountsData?.summary
                  ?.pending_accounts_count === undefined && "var(--padding-md)",
            }}
            className={`flex flex-col flex-1 items-center overflow-auto overflow-x-hidden w-full pb-padding-lg bg-primary-bg ${isAccountsLoading ? "h-full" : ""} `}
            onScroll={handleScroll}
          >
            {isAccountsLoading ? (
              <div className="loader-container m-auto justify-center items-center flex">
                <Loader />
              </div>
            ) : noResultsAfterFilter || noTransactionsFromAPI ? (
              <div
                className={
                  noResultsAfterFilter
                    ? "flex flex-col items-center justify-center m-auto w-full h-full"
                    : "flex flex-col justify-center items-center m-auto gap-gap-sm"
                }
              >
                <div
                  className={
                    noResultsAfterFilter
                      ? undefined
                      : "w-graphic-width-md h-graphic-square-height-md"
                  }
                >
                  <img
                    src={
                      noResultsAfterFilter
                        ? ICONS?.NO_DATA_FOUND
                        : ICONS?.NO_PENDING_TRANSACTION
                    }
                    alt={
                      noResultsAfterFilter
                        ? "No accounts found"
                        : "No pending transactions"
                    }
                    className={
                      noResultsAfterFilter
                        ? "w-graphic-width-md h-graphic-rectangle-height-md"
                        : undefined
                    }
                  />
                </div>

                <p
                  className={
                    noResultsAfterFilter
                      ? "text-text-primary text-font-sm font-normal text-center font-open-sans mb-margin-sm"
                      : "text-center text-font-sm text-text-primary"
                  }
                >
                  {noResultsAfterFilter
                    ? "No data found."
                    : "There are no more accounts that require your approval."}
                </p>

                <PrimaryButton
                  enabledBgColor="var(--primary-nav-act)"
                  btnText={emptyStateButtonProps.btnText}
                  btnType="button"
                  handleFunction={emptyStateButtonProps.handleFunction}
                  enabledTextColor="var(--text-primary)"
                />
              </div>
            ) : allAccounts?.length > GlobalConfiguration.lengthCheckZero ? (
              <div
                className="scroll flex flex-col items-center justify-center w-width-full"
                ref={filterRef}
              >
                <div className="scroll flex flex-col items-center justify-center w-width-full lg:w-auto px-padding-md lg:px-padding-base gap-gap-md">
                  {allAccounts?.map((account, index) => {
                    const buildAlerts = () => [
                      ...(account?.all_category_assign === "Y"
                        ? [
                            {
                              isLoading: false,
                              text: "All categories are assigned to this account",
                              icon: ICONS?.ALERT,
                              onClick: () => {
                                handleBeneAccountMoreDetails(account.id);
                                setShowCategory(true);
                              },
                            },
                          ]
                        : []),

                      ...(account?.associate_bank === "Y" ||
                      account?.associate_pan === "Y"
                        ? [
                            {
                              isLoading: false,
                              text: "Associated accounts are found",
                              icon: ICONS?.ALERT,
                              onClick: () => {
                                openAssociatedAccountsFound(
                                  account?.ifsc_code,
                                  account?.bank_acc_no,
                                  account?.pan_no,
                                  account?.id,
                                );
                              },
                            },
                          ]
                        : []),

                      ...(account?.pending_beneficiary_transactions === "Y"
                        ? [
                            {
                              isLoading: false,
                              text: "Pending transactions found",
                              icon: ICONS?.ALERT,
                              onClick: () => {
                                openTxnPopup(account?.id, account?.name);
                                setIsRejectPopupOpen(true);
                                setAssociateType("BeneTxn");
                                setAccountName(account?.name);
                              },
                            },
                          ]
                        : []),

                      ...(account?.pending_scheduled_beneficiary_transactions ===
                      "Y"
                        ? [
                            {
                              isLoading: false,
                              text: "Pending schedules found",
                              icon: ICONS?.ALERT,
                              onClick: () => {
                                openTxnPopup(account?.id, account?.name);
                                setShowScheduleTxnPopup(true);
                                setAssociateType("scheduleBeneTxn");
                                setAccountName(account?.name);
                              },
                            },
                          ]
                        : []),
                    ];
                    return (
                      <div
                        key={account.id}
                        className={`w-full ${index === 0 ? "mt-margin-md" : ""}`}
                      >
                        <CommonAccountApprovalCard
                          overrideAutoLoader
                          whichBtnClicked={
                            whichBtnClicked?.[account?.id] ?? "none"
                          }
                          entries={[
                            [
                              {
                                type: "textSubtext",
                                text: account.name,
                                subText: "Account name",
                              },
                              {
                                type: "textSubtext",
                                text: account.email_id,
                                subText: "Email ID",
                              },
                              {
                                type: "textSubtext",
                                text: "+91 " + account.contact_no,
                                subText: "Contact number",
                              },
                              {
                                type: "textSubtext",
                                text: account?.account_type,
                                subText: "Account type",
                              },
                            ],
                            [
                              {
                                type: "textSubtext",
                                text: account.bank_account_holder_full_name,
                                subText: "Bank account holder name ",
                              },
                              {
                                type: "accountNumber",
                                text: account.bank_acc_no,
                                subText: "Account number",
                                ifsc: account.ifsc_code,
                              },
                              {
                                type: "textSubtext",
                                text: account.ifsc_code,
                                subText: "IFSC",
                              },
                              {
                                type: "textSubtextX2",
                                text: account.pan_no,
                                subText: "PAN",
                                text1: account.gstin_detail || "Not given",
                                subText1: "GSTIN",
                              },
                            ],
                            [
                              {
                                type: "cta",
                                text:
                                  account?.labels?.join(", ") ||
                                  "No labels assigned",
                                subText: "Assigned labels",
                                onClick: (e) => {
                                  if (
                                    services?.includes("ALabel") &&
                                    services?.includes("RLabel")
                                  ) {
                                    e.stopPropagation();
                                    setLabelId([account?.id]);
                                    setLabelPopupAccounts(
                                      accumulatedData.filter(
                                        (acc) => acc?.id === account?.id,
                                      ),
                                    );
                                    setIsLabelPopupOpen(true);
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "ALabel,RLabel",
                                      },
                                    });
                                  }
                                },
                              },
                              {
                                type: "textSubtext",
                                text:
                                  account?.category_ids?.length >
                                  GlobalConfiguration.lengthCheckZero
                                    ? account.category_ids
                                        .map(
                                          (category) => category.category_name,
                                        )
                                        .join(", ")
                                    : "Not Assigned",
                                subText: "Assigned categories",
                              },
                            ],
                          ]}
                          approveClick={() => {
                            setWhichBtnClicked((p) => {
                              return {
                                ...p,
                                [account?.id]: "approve",
                              };
                            });
                            handleApproval(account.id);
                          }}
                          rejectClick={() => {
                            setWhichBtnClicked((p) => {
                              return {
                                ...p,
                                [account?.id]: "reject",
                              };
                            });
                            handleOpenPopup(account?.id);
                            openTxnPopup(account?.id, account?.name);
                            setAssociateType("rejectAccount");
                          }}
                          ctaBtn1Text={"More details"}
                          ctaBtn1OnClick={
                            account.approval_status === "pending" &&
                            !loading[account.id]
                              ? () => {
                                  handleBeneAccountMoreDetails(account.id);
                                  setShowCategory(false);
                                }
                              : undefined
                          }
                          cardState={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            approveBeneficiaryAccountData &&
                            !loading[account.id]
                              ? "single"
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? account.rejection_reason
                                  ? "double"
                                  : "single"
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? "single"
                                  : "default"
                          }
                          overlay1Text={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            approveBeneficiaryAccountData &&
                            !loading[account.id]
                              ? "Approved"
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? "Rejected"
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? "Failed to take action!"
                                  : undefined
                          }
                          overlay1Subtext={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            approveBeneficiaryAccountData &&
                            !loading[account.id]
                              ? "This account has been approved."
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? "This account has been rejected."
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? account.message ||
                                    "An error occurred while taking action on this account."
                                  : undefined
                          }
                          overlay1Icon={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            approveBeneficiaryAccountData &&
                            !loading[account.id]
                              ? ICONS?.APPROVED_LINEAR
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? ICONS?.REJECTED_RED
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                  : undefined
                          }
                          overlay1CtaText={
                            (account.approval_status === "Approved" &&
                              account.error === "false" &&
                              approveBeneficiaryAccountData &&
                              !loading[account.id]) ||
                            (account.approval_status === "error" &&
                              account.error === "true" &&
                              !loading[account.id]) ||
                            (account.approval_status === "rejected" &&
                              account.error === "false" &&
                              !loading[account.id])
                              ? "View account"
                              : undefined
                          }
                          overlay1CtaOnClick={
                            (account.approval_status === "Approved" &&
                              account.error === "false" &&
                              approveBeneficiaryAccountData &&
                              !loading[account.id]) ||
                            (account.approval_status === "error" &&
                              account.error === "true" &&
                              !loading[account.id]) ||
                            (account.approval_status === "rejected" &&
                              account.error === "false" &&
                              !loading[account.id])
                              ? () => {
                                  handleBeneAccountMoreDetails(account.id);
                                  setShowCategory(false);
                                }
                              : undefined
                          }
                          overlay1CtaInactive={false}
                          overlay1CtaDisabled={loading[account.id]}
                          overlay1CtaLoading={loading[account.id]}
                          overlay2Text={
                            account.approval_status === "rejected" &&
                            account.error === "false" &&
                            !loading[account.id]
                              ? account.rejection_reason
                              : undefined
                          }
                          overlay2Subtext={
                            account.approval_status === "rejected" &&
                            account.error === "false" &&
                            !loading[account.id]
                              ? "Rejected reason"
                              : undefined
                          }
                          alerts={buildAlerts()}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : null}
          </div>
          {!isAccountsLoading &&
            !noResultsAfterFilter &&
            !noTransactionsFromAPI && (
              <div
                className={`w-width-full bottom-bottom-base fixed ${
                  accumulatedData?.length ===
                    GlobalConfiguration.lengthCheckZero &&
                  filteredData?.length ===
                    GlobalConfiguration.lengthCheckZero &&
                  !loading
                    ? "hidden"
                    : "block"
                } z-z-index-content`}
              >
                {showInnerSearchBar && (
                  <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
                )}
                <div
                  className={`${showInnerSearchBar && "  pointer-events-none"}`}
                >
                  <PaginationComponent
                    handleSelect={handleSelect}
                    selectedValue={selectedValue}
                    data={accountSummaryData}
                    pageSize={pageSize}
                    dropdownOptions={dropdownOptions}
                    handlePagination={handlePagination}
                    currentPage={currentPage}
                    setIsOpen={setIsOpen}
                  />
                </div>
              </div>
            )}
        </div>
      </div>
    </>
  );
};

export default BeneficiaryAcountApproval;
